import de from './translations/de'
import fr from './translations/fr'

export default {
  de,
  fr
}